import DialogTitle from '@mui/material/DialogTitle';
import { palette } from '../../..';
import Dialog from '@mui/material/Dialog';
import React, { useState } from 'react';
import { CloseOutlined } from '@mui/icons-material';
import { Box, TextField } from '@mui/material';
import HoverButton from '../../Buttons/HoverButton';
import { ffButtonStyle, ffDialogTitle } from '../../DataConnection/muiStyles';
import { fontSize } from '../../..';
import RichTreeViewControl from '../../Controls/RichTreeViewControl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const SaveModal = ({
  saveModal,
  saveFromHomeIcon,
  saveFromLogoutIcon,
  subWorkspaceList,
  playBookDescription,
  playBookName,

  setSaveFromHomeIcon,
  setSaveFromLogoutIcon,
  setSaveModal,
  setOpenSaveCalculationDialogFromHomeIcon,
  setPlayBookDescription,
  setPlayBookName,

  handleDirectClick,
  savePlaybook,
  handleSave,
}: {
  saveModal: boolean;
  saveFromHomeIcon: boolean;
  saveFromLogoutIcon: boolean;
  subWorkspaceList: any;
  playBookName: string;
  playBookDescription: string | null;

  setSaveFromHomeIcon: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveFromLogoutIcon: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveModal: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSaveCalculationDialogFromHomeIcon: React.Dispatch<React.SetStateAction<boolean>>;
  setPlayBookName: React.Dispatch<React.SetStateAction<string>>;
  setPlayBookDescription: React.Dispatch<React.SetStateAction<string | null>>;

  handleDirectClick: (selectedWorkspaceID: string, list: any) => void;
  savePlaybook: () => Promise<void>;
  handleSave: (saveFromHome?: boolean) => Promise<void>;
}) => {
  const { playBookState } = useSelector((state: any) => {
    return {
      playBookState: state.playBookState,
    };
  });

  const [currentButtonEvent, setCurrentButtonEvent] = useState<any>({});
  const [currentClicked, setCurrentClicked] = useState<boolean>(false);

  const locationState = useLocation();

  const cancelAndSaveButtons = () => {
    return (
      <>
        <HoverButton
          sx={{
            ...ffButtonStyle,
            border: `1px solid ${palette.primary.contrastText}`,
            fontSize: fontSize.medium,
            lineHeight: 'normal',
          }}
          onClick={() => {
            setSaveModal(false);
          }}
          text="Cancel"
          hoverColor="secondary.contrastText"
          color="primary.contrastText"
          hoverBackgroundColor="primary.contrastText"
          backgroundColor="secondary.contrastText"
          transitionTime="0.2s"
        />
        <HoverButton
          onClick={() => {
            savePlaybook();
          }}
          text="Save"
          color="primary.main"
          hoverColor="secondary.contrastText"
          backgroundColor="secondary.contrastText"
          hoverBackgroundColor="primary.main"
          transitionTime="0.2s"
          sx={{
            ...ffButtonStyle,
            border: `1px solid ${palette.primary.main}`,
            fontSize: fontSize.medium,
            lineHeight: 'normal',
          }}
        />
      </>
    );
  };

  return (
    <Dialog
      open={saveModal}
      onClose={(event, reason) => {
        if (reason === 'escapeKeyDown') {
          setSaveFromHomeIcon(false);
          setSaveFromLogoutIcon(false);
          setSaveModal(false);
          setOpenSaveCalculationDialogFromHomeIcon(false);
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          // padding: "8px",
          width: '450px',
          height: 'auto',
          justifyContent: 'center',
        }}
      >
        <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
          <DialogTitle
            sx={{
              ...ffDialogTitle,
              background: '#424242',
              padding: '16px 20px 16px 24px',
            }}
          >
            <div>
              <b style={{ color: 'white' }}>Save Playbook</b>
            </div>

            <CloseOutlined
              onClick={() => {
                setSaveFromHomeIcon(false);
                setSaveFromLogoutIcon(false);
                setSaveModal(false);
                setOpenSaveCalculationDialogFromHomeIcon(false);
              }}
              style={{ color: 'white', paddingLeft: '4px' }}
            />
          </DialogTitle>
          {(saveFromHomeIcon || saveFromLogoutIcon) && playBookState.playBookUid !== null ? null : (
            <div style={{ padding: '0 20px' }}>
              <span style={{ textAlign: 'left' }}>Select a workspace</span>
              {
                <div style={{ maxHeight: '20rem', overflowY: 'auto' }}>
                  <RichTreeViewControl
                    currentButtonEvent={currentButtonEvent}
                    directClickedValue={currentClicked}
                    currentWorkspace={locationState?.state?.parentId}
                    list={subWorkspaceList}
                    title={'Select a Workspace'}
                    // showInPopup={true}
                    handleDirectClick={handleDirectClick}
                  />
                </div>
              }
              <Box
                sx={{
                  marginTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                }}
              >
                <TextField
                  required
                  size="small"
                  fullWidth
                  label="Playbook Name"
                  error={playBookName.length > 40}
                  helperText={
                    playBookName.length > 40 ? 'Playbook name cannot exceed 40 characters.' : ''
                  }
                  FormHelperTextProps={{
                    sx: {
                      fontSize: '12px',
                    },
                  }}
                  sx={{
                    '.MuiOutlinedInput-root': {
                      ...(playBookName.length > 40 && {
                        '& fieldset': {
                          borderColor: 'red',
                        },
                      }),
                    },
                    '& .MuiFormLabel-root': {
                      ...(playBookName.length > 40 && {
                        color: 'red',
                      }),
                    },
                  }}
                  variant="outlined"
                  onChange={(e) => setPlayBookName(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && playBookName.length <= 40) {
                      savePlaybook();
                    }
                  }}
                  value={playBookName}
                />
                <TextField
                  label="Description"
                  size="small"
                  fullWidth
                  sx={{
                    '.MuiOutlinedInput-root': {
                      // height: "2rem",
                      // fontSize: "12px",
                    },
                  }}
                  onChange={(e) => setPlayBookDescription(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      savePlaybook();
                    }
                  }}
                />
                <div
                  style={{
                    paddingBottom: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnGap: '1rem',
                  }}
                >
                  <HoverButton
                    text="Current Workspace"
                    color="secondary.light"
                    hoverColor="secondary.contrastText"
                    backgroundColor="secondary.contastText"
                    hoverBackgroundColor="secondary.light"
                    sx={{
                      ...ffButtonStyle,
                      border: `1px solid ${palette.secondary.light}`,
                      fontSize: fontSize.medium,
                      lineHeight: 'normal',
                    }}
                    onClick={(e) => {
                      setCurrentClicked(!currentClicked);
                      setCurrentButtonEvent(e);
                    }}
                    transitionTime="0.2s"
                  />

                  <Box sx={{ display: 'flex', gap: '1rem' }}>{cancelAndSaveButtons()}</Box>
                </div>
              </Box>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default SaveModal;
